export var PnEvents;
(function (PnEvents) {
    PnEvents["Join"] = "join";
    PnEvents["Leave"] = "leave";
    PnEvents["Unsubscribe"] = "unsubscribe";
    PnEvents["StateUpdate"] = "stateUpdate";
    PnEvents["Connected"] = "connected";
    PnEvents["Message"] = "message";
    PnEvents["ForceRemove"] = "forceRemove";
    PnEvents["AccessDenied"] = "accessDenied";
})(PnEvents || (PnEvents = {}));
export var PnPersonEvents;
(function (PnPersonEvents) {
    PnPersonEvents["StatusUpdated"] = "statusUpdated";
})(PnPersonEvents || (PnPersonEvents = {}));
